import React, { createContext, useState } from "react";
import { BrowserRouter, Routes, Route, Navigate, useParams } from "react-router-dom";
import ReactGA from "react-ga";
import "./index.css";

import { SiteProvider } from "./site/hooks/useSite";
import SiteShell from "./site/components/SiteShell";
import HomePage from "./site/pages/HomePage";
import MenuPage from "./site/pages/MenuPage";
import MenuItemPage from "./site/pages/MenuItemPage";
import DishPage from "./site/pages/DishPage";
import EducationPage from "./site/pages/EducationPage";
import StoryPage from "./site/pages/StoryPage";
import FaqPage from "./site/pages/FaqPage";
import FindUsPage from "./site/pages/FindUsPage";
import PairingsPage from "./site/pages/PairingsPage";
import PairingPage from "./site/pages/PairingPage";
import EventsPage from "./site/pages/EventsPage";
import EventKindPage from "./site/pages/EventKindPage";
import BookEventPage from "./site/pages/BookEventPage";
import FeedbackPage from "./site/pages/FeedbackPage";
import ClubPage from "./site/pages/ClubPage";
import OffersPage from "./site/pages/OffersPage";
import IngredientsPage from "./site/pages/IngredientsPage";
import AmbassadorPage from "./site/pages/AmbassadorPage";
import LegalPage from "./site/pages/LegalPage";
import NotFoundPage from "./site/pages/NotFoundPage";

export const LangContext = createContext();

ReactGA.initialize("UA-230074267-1");

// Old menu item URLs keep working.
function LegacyItemRedirect() {
  const { productId } = useParams();
  return <Navigate to={`/menu/item/${productId}`} replace />;
}

// Previous application routes, redirected to their new homes. Routes that
// differ only by case (/Events, /Feedback, /Ingredients, /Ambassador) already
// match the new pages because matching is case-insensitive.
const legacyRedirects = [
  ["/Comp", "/menu/c/ice-cream-rolls"],
  ["/Instore", "/events/in-store"],
  ["/Outdoor", "/events/outdoor"],
  ["/ContactUs", "/book-event"],
  ["/Subscription", "/club"],
  ["/About", "/our-story"],
  ["/image", "/our-story"],
  ["/Blogcont", "/pairings"],
  ["/NewArrivals", "/offers"],
  ["/Nutrition", "/ingredients"],
  ["/Categories", "/ingredients"],
];

function App() {
  const [langEng, setLangEng] = useState(true);
  return (
    <LangContext.Provider value={{ langEng, setLangEng }}>
      <BrowserRouter>
        <SiteProvider>
          <SiteShell>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/what-is-rollover" element={<EducationPage />} />
              <Route path="/our-story" element={<StoryPage />} />
              <Route path="/menu" element={<MenuPage />} />
              <Route path="/menu/c/:categorySlug" element={<MenuPage />} />
              <Route path="/menu/item/:id" element={<MenuItemPage />} />
              <Route path="/menu/:slug" element={<DishPage />} />
              <Route path="/faqs" element={<FaqPage />} />
              <Route path="/find-us" element={<FindUsPage />} />
              <Route path="/pairings" element={<PairingsPage />} />
              <Route path="/pairings/:slug" element={<PairingPage />} />
              <Route path="/events" element={<EventsPage />} />
              <Route path="/events/:kind" element={<EventKindPage />} />
              <Route path="/events/:kind/:occasion" element={<EventKindPage />} />
              <Route path="/book-event" element={<BookEventPage />} />
              <Route path="/feedback" element={<FeedbackPage />} />
              <Route path="/club" element={<ClubPage />} />
              <Route path="/offers" element={<OffersPage />} />
              <Route path="/ingredients" element={<IngredientsPage />} />
              <Route path="/ambassador" element={<AmbassadorPage />} />
              <Route path="/terms" element={<LegalPage type="terms" />} />
              <Route path="/privacy" element={<LegalPage type="privacy" />} />
              <Route path="/Comp/:productId" element={<LegacyItemRedirect />} />
              {legacyRedirects.map(([from, to]) => (
                <Route key={from} path={from} element={<Navigate to={to} replace />} />
              ))}
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </SiteShell>
        </SiteProvider>
      </BrowserRouter>
    </LangContext.Provider>
  );
}

export default App;
